export { CreateIndex as GuildCreateIndexView } from './CreateIndex'
